const { drugDisposableonStorage, drugDisposableReturned, siteDrugDisposable } = require('@/api/disposed')
import helpers from '../../helpers'

export default {
  'entityName': 'disposed_has_drug',
  'title': 'Drug to destroy',
  // id: ['id'],
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'drug_id',
    'descending': true
  },
  'fields': [
    {
      'value': 'drug_id',
      'text': 'Drug',
      // reference: 'siteresponse_has_drug',
      list: (entity, search, item) => item.parent_site_id ? siteDrugDisposable({ search, protocol_id: item.protocol_id, site_id: item.parent_site_id, destroy_expired: item.destroy_expired }) :
        (item.storage_id ? drugDisposableonStorage({ search, protocol_id: item.protocol_id, destroy_expired: item.destroy_expired, storage_id: item.storage_id }) : drugDisposableReturned({ search, protocol_id: item.protocol_id,  disposal_id: item.disposal_id})),
      'type': 'autocomplete',
      'title': 'name',
      subtitle: ( drug ) => `${drug.packaging}, ${drug.dose || drug.labels?.join(',')}${drug.measure_unit}${(drug.countries && drug.countries !== '[]') ? ' - ' + JSON.parse(drug.countries).join(', ') : ''}`,
        // drug.packaging !== 'Labels' ? `${drug.packaging}, ${drug.dose}${drug.measure_unit}` : `${drug.packaging} - ${drug.labels && drug.labels.join(',')}`,
      table: true,
      render: ({drug}) => drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      validators: ['required'],
      small: true
    },
    {
      value: '_lotto',
      text: 'Batch number',
      title: 'lotto',
      subtitle: item => `${item.n_available+item.n_partially} / ${item.type} ${item.site_city} / ${item.expiration}`,
      list: (entity, search, item) =>  item.parent_site_id ? siteDrugDisposable({ search, protocol_id: item.protocol_id, site_id: item.parent_site_id, destroy_expired: item.destroy_expired, drug_id: item.drug_id }) :
      (item.storage_id ? drugDisposableonStorage({ search, protocol_id: item.protocol_id, destroy_expired: item.destroy_expired, drug_id: item.drug_id, storage_id: item.storage_id }) : drugDisposableReturned({ search, protocol_id: item.protocol_id,  disposal_id: item.disposal_id, drug_id: item.drug_id})),
      render: item => item.lotto,
      id: 'id',
      // table: true,
      default: (item, args, selected) => {
        if (!selected) return
        item.drug = selected
      },
      deps: ['drug_id'],
      type: 'autocomplete',
      readonly: item => !item.drug_id,
      small: true,
      validators: ['required']
    },
    {
      value: 'lotto',
      visible: false,
      text: 'Batch number',
      table: true,
      deps: ['_lotto'],
      default: (item, args, selected) => selected && selected.lotto
    },
    {
      value: 'type',
      text: 'Type',
      deps: ['lotto'],
      visible: false,
      table: true,
      render: item => item.type === 'RETURNED' ? `<a href='#/returned/${item.returned_id}'>RETURNED from ${item.site.city}</a>` : item.type,
      default: (item, args, selected) => selected && selected.type,
    },
    {
      value: 'site_id',
      deps: ['lotto'],
      default: (item, args, selected) => selected && selected.site_id || null,
      type: 'hidden'
    },
    {
      value: 'returned_id',
      deps: ['lotto'],
      type: 'hidden',
      default: (item, args, selected) => selected && selected.returned_id || null
    },
    {
      value: '_n_available_pieces',
      deps: ['lotto'],
      default: (item, args, selected) => selected && selected.n_available + selected.n_partially,
      visible: false
    },
    {
      value: 'expiration',
      small: true,
      text: 'Expiration',
      table: true,
      type: 'text',
      readonly: true,
      deps: ['lotto'],
      default: (item, args, selected) => selected && selected.expiration
    },
    {
      full: true,
      "value": "_original_serials",
      text: 'Available Serials',
      deps: ['lotto'],
      default: (item, args, selected) => {
        if (selected && args.value === 'drug_id') { 
          return ''
        }
        return selected && args.value === 'lotto' && helpers.compatSerials(helpers.mergeSerials(selected.serials_partially, selected.serials))
      },
      visible: item => !!item._original_serials && item.type !== 'RETURNED',
      readonly: true
    },
    {
      value: '_serials',
      text: 'Unused serials to destroy',
      type: 'textarea',
      deps: ['_original_serials', '_lotto'],
      default: (item, args, selected) => item.type === 'RETURNED' && selected && selected.serials || '',
      readonly: item => !item._original_serials || item.type === 'RETURNED',
      visible: item => !!item._original_serials,
      "validators": [
        "serials",
        (field, value, item) => {
          if (!item._original_serials) return true
          const ret = helpers.subtractSerials(value, item._original_serials)
          if (ret.length) {
            const notAvailable = helpers.compatSerials(ret)
            return `Serials ${notAvailable} not available`
          }
          
          const n = helpers.nSerials(value) + helpers.nSerials(item.serials_partially)
          if (n === 0) {
            return 'Should destroy something'
          }

          return true
        }
    ]},    
    {
      value: 'serials',
      type: 'hidden',
      deps: ['_serials'],
      default: item => item._serials && helpers.compatSerials(helpers.explodeSerials(item._serials))
    },
    {
      value: '_serials_partially',
      text: 'Partially used serials to destroy',
      type: 'textarea',
      deps: ['_original_serials', 'lotto'],
      readonly: item => item.type === 'RETURNED',
      default: (item, args, selected) => (item.type === 'RETURNED' && selected && selected.serials_partially) || '',
      visible: item => !!item._original_serials,
      "validators": [
        (field, value, item) => !Number(value) || item.drug.n_pieces > 1 || `${item.drug.name} (${item.drug.packaging} ${item.drug.dose}${item.drug.measure_unit}) could not be partially used`,
        // "required",
        "serials",
        (field, value, item) => {
          if (!item._original_serials) return true
          let ret = helpers.subtractSerials(item._original_serials, item.serials)

          ret = helpers.subtractSerials(value, ret)

          if (ret.length) {
            let notAvailable = helpers.compatSerials(ret)
            return `Serials ${notAvailable} not available`
          }
          return true
        }
    ]},
    {
      value: 'serials_partially',
      type: 'hidden',  
      deps: ['_serials_partially'],
      default: item => item._serials_partially && helpers.compatSerials(helpers.explodeSerials(item._serials_partially))
    },
    {
      'value': 'n_pieces',
      'text': 'N. unused box',
      'type': 'number',
      deps: ['serials', 'lotto'],
      // default: (item, args, selected) => args.value === 'lotto' ? selected && selected.n_partially : helpers.nSerials(item.serials_partially),
      default: (item, args, selected) => item.type === 'RETURNED' ? selected && selected.n_available : (item.serials && helpers.nSerials(item.serials) || 0),
      render: item => item.n_pieces + (item.serials && ` (${item.serials.replaceAll(',', ', ')})`),
      'table': {
        'sortable': true,
        'filter': false
      },
      readonly: item => (item.type === 'RETURNED') || ((!item.lotto || !!item._original_serials) && (!item.n_partially || !!item.n_partially)),
      'validators': [
        'number',
        (field, value, item) => value+item.n_partially <= item._n_available_pieces || `Should be <= of available pieces (${item.n_pieces} + ${item.n_partially} > ${item._n_available_pieces})`,
        (field, value, item) => {
          return (value + item.n_partially) > 0 || `Should destroy something`
        }
      ]
    },
    {
      value: 'n_partially',
      text: 'N. partially used box',
      type: 'number',
      table: true,
      render: item => item.n_partially + (item.serials_partially && ` (${item.serials_partially.replaceAll(',', ', ')})`),
      deps: ['serials_partially', 'lotto'],
      // readonly: item => !['ON STORAGE', 'EXPIRED ON STORAGE'].includes(item.type),
      default: (item, args, selected) => {
        if (item.drug && item.drug.n_pieces <= 1) { return 0 }
        return item.type === 'RETURNED' ? selected && selected.n_partially : (item.serials_partially && helpers.nSerials(item.serials_partially) || 0)
        // return item.serials_partially ? helpers.nSerials(item.serials_partially) : (item.type === 'RETURNED' && selected && selected.n_partially) || 0 
      },
      // default: (item, args, selected) => args.value === 'lotto' ? selected && selected.n_partially : helpers.nSerials(item.serials_partially),
      readonly: item => !item.lotto || !!item._original_serials || ['RETURNED', 'ON STORAGE', 'EXPIRED ON STORAGE'].includes(item.type),
      validators: [
          (field, value, item) => !Number(value) || item.drug.n_pieces > 1 || `${item.drug.name} (${item.drug.packaging} ${item.drug.dose}${item.drug.measure_unit}) could not be partially used`,
          'number'
      ]
    },
  ],
  actions: [
    {
      value: 'partially',
      text: 'Partially used details',
      color: 'primary',
      icon: 'mdi-adjust',
      disable: item => item.type === 'RETURNED' || !item.n_partially || !['Bottle CPS', 'Blister', 'Vials'].includes(item.drug.packaging)
    },    
    {
      value: 'remove',
      text: 'Remove',
      color: 'primary',
      icon: 'mdi-delete',
      disable: item => item.disposed.status !== 'INIT'
    }
  ]
}
